module.exports = __webpack_public_path__ + "static/img/upload_1.cbfedb68.png";